<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xrErrT/tc-custom/9781464209703.jpg?1726617300427" alt="This image is the cover for the book Blood on the Tracks, British Library Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood on the Tracks, British Library Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover the captivating treasures buried in the British Library's archives. Largely inaccessible to the public until now, these enduring classics were written in the golden age of detective fiction.</b></p><p>"This is the perfect volume for fans of short, high-quality, fair-play detective fiction." —<i>Publishers Weekly</i></p><p>"Never had I been given a tougher problem to solve, and never had I been so utterly at my wits' end for a solution."</p><p>A signalman is found dead by a railway tunnel. A man identifies his wife as a victim of murder on the underground. Two passengers mysteriously disappear between stations, leaving behind a dead body.</p><p>Trains have been a favourite setting of many crime writers, providing the mobile equivalent of the "locked-room" scenario. Their enclosed carriages with a limited number of suspects lend themselves to seemingly impossible crimes. In an era of cancellations and delays, alibis reliant upon a timely train service no longer ring true, yet the railway detective has enjoyed a resurgence of popularity in the twenty-first century.</p><p>Both train buffs and crime fans will delight in this selection of fifteen railway-themed classic mysteries, featuring some of the most popular authors of their day alongside less familiar names. This is a classic short story collection to beguile even the most wearisome commuter.</p><p><b>These fascinating mystery stories are:</b></p>For fans of Agatha Christie and Anthony HorowitzPerfect for readers of Classic Crime Fiction and Golden-Age Murder Mysteries<p><b>Also in the British Library Crime Classics:</b></p><p><i>Smallbone Deceased</i></p><p><i>The Body in the Dumb River</i></p><p><i>Blood on the Tracks</i></p><p><i>Surfeit of Suspects</i></p><p><i>Death Has Deep Roots</i></p><p><i>Checkmate to Murder</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Edwards
      </h2>
      
      <p class="authorDescription body article"><P>Martin Edwards is an award-winning crime writer best known for two series of novels set in Liverpool and the Lake District. He is series consultant for British Library Crime Classics, the Vice Chair of the Crime Writers' Association, and President of the Detection Club. The Golden Age of Murder, his study of the Detection Club, was published in 2015 to international acclaim, and has been nominated for both the Edgar and Agatha awards for the year's best book about the genre. He received the CWA 2020 Diamond Dagger Award for sustained excellence in crime writing and significant contributions to the genre, joining the ranks of Sue Grafton, Ian Rankin, and Lee Child.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10324388